import { host, privateClient } from '.';

const path = '/requerimentos';

const getBaseUrl = () => `${host}${path}`;

async function CriaRequerimento(dados) {
	return await privateClient({
		path: `${path}`,
		params: {
			method: 'POST',
			body: JSON.stringify(dados),
		},
	});
}

async function ConsultaRequerimentoPelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
	});
}

async function ListaRequerimentos() {
	return await privateClient({
		path: `${path}`,
	});
}

async function RemoveRequerimentoPelaId(id) {
	return await privateClient({
		path: `${path}/${id}`,
		params: {
			method: 'DELETE',
		},
	});
}

const requerimentos = {
	getBaseUrl,
	CriaRequerimento,
	ConsultaRequerimentoPelaId,
	ListaRequerimentos,
	RemoveRequerimentoPelaId,
};

export default requerimentos;
